export default __webpack_public_path__ + "static/media/default.e5b8c7ac80daa84091dfe4747ec01096.png";